import React from 'react';

import classes from './Scroll.module.scss';

const scroll = (props) => (
    <div className={[classes.Scroll, props.className, classes[props.scrollType]].join(' ')}>
        {props.children}
    </div>
);

export default scroll;